import type { Request } from 'express'

import countryConfigs, { CountryConfig } from './countryConfigs'

const envI18nCountryCode = (process.env.I18N_COUNTRY_CODE || '').trim().toUpperCase() || 'AT'

export function getSettingsForHostname(hostname: string): CountryConfig {
  // Port could be set on hostname, especially when not default port 80
  const normalizedHostname = hostname.split(':')[0]
  for (const countryConfig of countryConfigs.values()) {
    // We first want to look at the internal hostname
    if (countryConfig.internalHostname && countryConfig.internalHostname === normalizedHostname) {
      return countryConfig
    }

    if (countryConfig.hostname === normalizedHostname) {
      return countryConfig
    }
  }

  const fallback = countryConfigs.get(envI18nCountryCode)
  if (!fallback) {
    throw new Error('country fallback not found')
  }

  return fallback
}

export function getSettingsForCountryCode(countryCode: string): CountryConfig {
  return countryConfigs.get(countryCode)
}

export function getCountryConfigForRequest(request: Request): CountryConfig {
  const host = request.headers.host
  if (!host) {
    throw new Error('No host defined on the request headers')
  }
  return getSettingsForHostname(host)
}

export default countryConfigs

export { supportedCountryCodes, getCountryConfigHostnamesForStage } from './countryConfigs'
